/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  {
    url: "/companies",
    name: "Empresas",
    slug: "companies",
    icon: "BriefcaseIcon",
    i18n: "companies",
    submenu: [
      {
        url: "/registered-companies",
        name: "Empresas cadastradas",
        slug: "registered-companies",
        i18n: "registered-companies"
      },
      {
        url: "/company",
        name: "Novas empresas",
        slug: "company",
        i18n: "company"
      },
      {
        url: "/companies-in-approval",
        name: "Empresas em aprovação",
        slug: "companies-in-approval",
        i18n: "companies-in-approval"
      }
    ]
  },
  {
    url: "/Partnerships",
    name: "Parceiros",
    icon: "UsersIcon",
    slug: "partnerships",
    i18n: "partnerships",
    submenu: [
      {
        url: "/PartnershipsRegistered",
        name: "Parceiros Cadastrados",
        slug: "partnershipsRegistered",
        i18n: "partnershipsRegistered"
      },
      {
        url: "/Partnerships",
        name: "Novos Parceiros",
        slug: "partnerships",
        i18n: "partnerships"
      },
    ]
  },
  {
    url: "/commercial-campaigns",
    name: "Campanhas",
    slug: "commercial-campaigns",
    icon: "ShoppingBagIcon",
    i18n: "commercial-campaigns",
    submenu: [
      {
        url: "/b2c-plans",
        name: "Planos de Assinaturas",
        slug: "b2c-plans",
        i18n: "b2c-plans"
      },
      //// MOCK2REMOVE
      {
        url: "/specialties-management",
        name: "Gerenciamento de Especialidades",
        slug: "specialties-management",
        i18n: "specialties-management"
      },
      //// MOCK2REMOVE
      {
        url: "/all-campaigns",
        name: "Modelo de Contratação",
        slug: "all-campaigns",
        i18n: "all-campaigns"
      }
    ]
  },
  {
    url: "/back-office",
    name: "Back-office",
    slug: "back-office",
    icon: "BoldIcon",
    i18n: "back-office",
    submenu: [
      {
        url: "/back-office-orizon",
        name: "Orizon",
        slug: "back-office-orizon",
        i18n: "back-office-orizon"
      },
      {
        url: "/back-office-cards",
        name: "Cartões",
        slug: "back-office-cards",
        i18n: "back-office-cards"
      }
    ]
  },
  {
    url: "/aas",
    name: "AAS",
    slug: "aas",
    icon: "ListIcon",
    i18n: "aas",
    submenu: [
      {
        url: "/aas-registered-agents",
        name: "Agentes cadastrados",
        slug: "registered-agents",
        i18n: "registered-agents"
      },
      {
        url: "/aas-new-agents",
        name: "Novos agentes",
        slug: "new-agents",
        i18n: "new-agents"
      },
      {
        url: "/aas-coupon-association",
        name: "Gerenciamento de cupons",
        slug: "aas-coupon-association",
        i18n: "aas-coupon-association"
      }
    ]
  },
  {
    url: "/commercial-reports",
    name: "Relatórios",
    slug: "commercial-reports",
    icon: "FileTextIcon",
    i18n: "commercial-reports",
    submenu: [
      {
        url: "/customers-commercial-report",
        name: "Clientes",
        slug: "customers-commercial-report",
        i18n: "customers-commercial-report"
      },
      {
        url: "/inactive-employees-report",
        name: "Empregados inativos",
        slug: "inactive-employees-report",
        i18n: "inactive-employees-report"
      },
      {
        url: "/quicksight-commercial-dashboard",
        name: "Painéis BI",
        slug: "quicksight-commercial-dashboard",
        i18n: "quicksight-commercial-dashboard"
      },
      {
        url: "/natural-person-customers",
        name: "Vendas Assinaturas",
        slug: "natural-person-customers",
        i18n: "natural-person-customers"
      },
      {
        url: "/pending-subscriptions-report",
        name: "Assinaturas não finalizadas",
        slug: "pending-subscriptions-report",
        i18n: "pending-subscriptions-report"
      },
      {
        url: "/unified-business-report",
        name: "Relatório Comercial Unificado",
        slug: "unified-business-report",
        i18n: "unified-business-report"
      },
      {
        url: "/expired-invoices",
        name: "Boletos Vencidos",
        slug: "expired-invoices",
        i18n: "expired-invoices"
      }
    ]
  },

  {
    url: "/customers-without-first-access",
    name: "Clientes sem o Primeiro Acesso",
    icon: "UserXIcon",
    slug: "customers-without-first-access",
    i18n: "customers-without-first-access"
  },
  {
    url: "/commercial-register",
    name: "Cadastros",
    slug: "register-commercial",
    icon: "ArchiveIcon",
    i18n: "register-commercial",
    submenu: [
      {
        url: "/associate-service-package",
        name: "Associação de serviços e pacotes",
        slug: "associate-service-package",
        i18n: "associate-service-package"
      },
      {
        url: "/advertising-message",
        name: "Cadastro de mensagem aos pacientes",
        slug: "advertising-message",
        i18n: "advertising-message"
      },
      {
        url: "/register-plan-package",
        name: "Cadastro de pacote de planos",
        slug: "register-package",
        i18n: "register-package"
      },
      {
        url: "/register-plan-service",
        name: "Cadastro de serviços de planos",
        slug: "register-plan-service",
        i18n: "register-plan-service"
      },
      {
        url: "/external-provider",
        name: "Cadastro de Fornecedor",
        slug: "external-provider",
        i18n: "external-provider"
      },
      {
        url: "/external-provider-token",
        name: "Cadastro de Token",
        slug: "external-provider-token",
        i18n: "external-provider-token"
      }
    ]
  },

  {
    url: "/health-plan-transfer",
    name: "Transferência Plano de Assinatura",
    icon: "RefreshCcwIcon",
    slug: "health-plan-transfer",
    i18n: "health-plan-transfer"
  }
];
